var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g2 = [2, 99].includes(_vm.currentTab)
  var l0 = _vm.__map(_vm.coupons, function (item, __i1__) {
    var $orig = _vm.__get_orig(item)
    var m0 = _vm.currentTab === 0 ? _vm.formatDate(item.createDate) : null
    var m1 = _vm.currentTab === 0 ? _vm.formatDate(item.validDate) : null
    var m2 = !(_vm.currentTab === 0) ? _vm.formatDate(item.startDate) : null
    var m3 = !(_vm.currentTab === 0) ? _vm.formatDate(item.endDate) : null
    var g0 = ((item.price || 0) / 100).toFixed(2)
    var g1 =
      item.couponType === 0 ? ((item.limitPrice || 0) / 100).toFixed(2) : null
    return {
      $orig: $orig,
      m0: m0,
      m1: m1,
      m2: m2,
      m3: m3,
      g0: g0,
      g1: g1,
    }
  })
  if (!_vm._isMounted) {
    _vm.e0 = function ($event, tab) {
      var _temp = arguments[arguments.length - 1].currentTarget.dataset,
        _temp2 = _temp.eventParams || _temp["event-params"],
        tab = _temp2.tab
      var _temp, _temp2
      _vm.currentTab = tab.value
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g2: g2,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }